//文字コードはutf-8

/* SP横スクロールリスト（Swiper / 1 slide per view）
========================================================*/
/* global Swiper */
export function initSpListScroll() {
    const lists = document.querySelectorAll('.jsListSp');
    if (!lists.length || typeof Swiper === 'undefined') return;

    const mq = window.matchMedia('screen and (max-width: 768px)');

    lists.forEach(function (list) {
        const items = list.querySelectorAll('.modListCard__item');
        if (!items.length) return;

        let swiperInstance = null;

        // Create Swiper DOM structure
        const swiperContainer = document.createElement('div');
        swiperContainer.className = 'swiper modListCard__swiper';

        // Pagination
        const paginationWrap = document.createElement('div');
        paginationWrap.className = 'modListCard__pagination';

        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'modListCard__pagination__arrow modListCard__pagination__arrow--prev';
        prevBtn.setAttribute('aria-label', '前へ');

        const pageText = document.createElement('span');
        pageText.className = 'modListCard__pagination__text';

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'modListCard__pagination__arrow';
        nextBtn.setAttribute('aria-label', '次へ');

        paginationWrap.appendChild(prevBtn);
        paginationWrap.appendChild(pageText);
        paginationWrap.appendChild(nextBtn);

        function updatePageText(swiper) {
            pageText.innerHTML = '<span class="currentSlide">' + (swiper.realIndex + 1) + '</span> / ' + items.length;
        }

        function setup() {
            if (!mq.matches || swiperInstance) return;

            // Convert list to swiper-wrapper, items to swiper-slide
            list.classList.add('swiper-wrapper');
            items.forEach(function (item) {
                item.classList.add('swiper-slide');
            });

            // Wrap list in swiper container
            list.parentNode.insertBefore(swiperContainer, list);
            swiperContainer.appendChild(list);

            // Insert pagination after swiper
            swiperContainer.parentNode.insertBefore(paginationWrap, swiperContainer.nextSibling);

            swiperInstance = new Swiper(swiperContainer, {
                slidesPerView: 'auto',
                spaceBetween: 16,
                loop: true,
                on: {
                    init: function (swiper) {
                        updatePageText(swiper);
                    },
                    slideChange: function (swiper) {
                        updatePageText(swiper);
                    }
                }
            });

            prevBtn.addEventListener('click', handlePrev);
            nextBtn.addEventListener('click', handleNext);
        }

        function handlePrev() {
            if (swiperInstance) swiperInstance.slidePrev();
        }

        function handleNext() {
            if (swiperInstance) swiperInstance.slideNext();
        }

        function teardown() {
            if (!swiperInstance) return;

            prevBtn.removeEventListener('click', handlePrev);
            nextBtn.removeEventListener('click', handleNext);

            swiperInstance.destroy(true, true);
            swiperInstance = null;

            // Restore DOM
            list.classList.remove('swiper-wrapper');
            items.forEach(function (item) {
                item.classList.remove('swiper-slide');
                item.removeAttribute('style');
            });

            swiperContainer.parentNode.insertBefore(list, swiperContainer);
            swiperContainer.remove();
            paginationWrap.remove();
        }

        if (mq.matches) {
            setup();
        }

        mq.addEventListener('change', function (e) {
            if (e.matches) {
                setup();
            } else {
                teardown();
            }
        });
    });
}
